import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';

import { getAllLibraryIconNames } from '@ml/web-components';
import { SharedAppModule } from '../shared/shared-app.module';

@Component({
    selector: 'icons',
    templateUrl: './icons.component.html',
    styleUrls: ['./icons.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SharedAppModule]
})
export class IconsComponent implements OnInit {
  iconNames = getAllLibraryIconNames();

  constructor() {}

  ngOnInit(): void {}
}
